import {
    VERIFY_MAIL,
    VERIFY_MAIL_SUCCESSFUL,
    VERIFY_MAIL_FAILED,
    VERIFY_ACCESS_TOKEN,
    VERIFY_ACCESS_TOKEN_SUCCESS,
    VERIFY_ACCESS_TOKEN_FAILED
  } from "./actionTypes"
  
  export const verifyMail = user => {
    return {
      type: VERIFY_MAIL,
      payload: { user },
    }
  }
  
  export const verifyMailSuccessful = user => {
    return {
      type: VERIFY_MAIL_SUCCESSFUL,
      payload: user,
    }
  }
  
  export const verifyMailFailed = user => {
    return {
      type: VERIFY_MAIL_FAILED,
      payload: user,
    }
  }
  export const verifyAccessToken = token => {
    return {
      type: VERIFY_ACCESS_TOKEN,
      payload: { token },
    }
  }
  
  export const verifyAccessTokenSuccessful = response => {
    return {
      type: VERIFY_ACCESS_TOKEN_SUCCESS,
      payload: response,
    }
  }
  
  export const verifyAccessTokenFailed = response => {
    return {
      type: VERIFY_ACCESS_TOKEN_FAILED,
      payload: response,
    }
  }
  